import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Nodes from "csi/store/Nodes";
import ColumnAssociation from "csi/table/matrix/ColumnAssociation";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";

const ColumnMatrix = declare(ColumnAssociation, {
	columnAssociation: "Composition",
	hideLoneSubheader: true,

	/** @property {C8Node[]} compositions - list of composition column nodes */
	compositions: null,

	/**
	 * @override
	 * Query for all composition nodes for matrix columns
	 */
	addDeferred(ctx: Context, h: Heading, dfds: Promise<any>[]): void {
		const _compStore = new Nodes({
			typeNode: "Composition",
		});

		const dfd = _compStore.asyncQuery().then((results) => {
			this.compositions = Array.from(results);
		});

		dfds.push(dfd);
		this.inherited<void>(arguments);
	},

	/**
	 * @override
	 * Return composition nodes for columns
	 */
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] {
		return this.compositions;
	},
});

export = ColumnMatrix;